<template>
  <div>
    <div class = "modal modal--prize-details"
         id = "spinning">
      <div class = "modal__content">
        <button class = "btn modal-close">
          <i class = "icon-close"></i>
        </button>
        <div class = "modal__header">
          <h1>{{ getTranslations.notifications_spin_wheel_spin_and_win }}</h1>
          <h3>{{ getTranslations.notifications_spin_wheel_spin_the_wheel }}</h3>
        </div>
        <div class = "modal__body welcone_pad">
          <div id = "wrapper">
            <div id = "wheel" @click.prevent="spin()" :style="styleClick()">
              <div id="inner-wheel" :class="[disableDuration ? 'noSpin' : 'spinNormal']">
                <div class="sec"><span class="fa icon-2gb"></span></div>
                <div class="sec"><span class="fa icon-try_again"></span></div>
                <div class="sec"><span class="fa icon-try_again2"></span></div>
                <div class="sec"><span class="fa icon-3gb"></span></div>
                <div class="sec"><span class="fa icon-try_again2"></span></div>
                <div class="sec"><span class="fa icon-1gb"></span></div>
              </div>
              <div id = "spin">
                <div id = "inner-spin"></div>
              </div>
              <div id = "shine"></div>
            </div>
          </div>
          <div v-show="showResult" :class = "['lost', (hasMadeASpin && !determineResult() ? '' : 'hide')]">
            <span class = "spin-lost">{{ getTranslations.home_modals_spin_wheel_lost }}</span>
          </div>
          <div v-show="showResult" :class = "['win', (hasMadeASpin && determineResult() ? '' : 'hide')]">
            <span class = "spin-win">{{ getTranslations.home_modals_spin_wheel_congrats }}</span><br>
            <span class = "spin-win">{{ getTranslations.home_modals_spin_wheel_win }} {{ getTranslations[prizeName] }}</span>
          </div>
        </div>
      </div>
    </div>
    <div class = "modal-overlay"></div>
  </div>
</template>

<script>
import { mapState, mapGetters, mapMutations, mapActions } from 'vuex';
import { spinTheWheel } from '@/common/jQuery';

export default {
  name: 'spin-wheel',
  data() {
    return {
      numOfClicks: 0,
      degree: 1800,
      result: '',
      hasMadeASpin: false,
      clicked: false,
      prizeName: '',
      normalDurationPassed: false,
      haveRewardResponse: false,
      showResult: false,
      disableDuration: false,
    };
  },
  created() {
    this.showModal();
    if (this.checkedNotificationId && this.checkedNotificationReadStatus) {
      this.setDisableDuration();
      const spinPosition = this.calculateResult();
      this.$nextTick(() => { spinTheWheel(this.numOfClicks, this.degree, spinPosition); });
      this.hasMadeASpin = true;
      this.clicked = true;
      this.prizeName = this.notificationRewardName;
      this.result = this.notificationPrizeWon ? 'WIN' : 'LOSE';
      this.showResult = true;
      this.clearData();
    }
  },
  methods: {
    ...mapMutations('profile', [
      'setNotificationRewardId',
      'setCheckedNotificationId',
      'setNotificationRewardName',
      'setNotificationPrizeWon',
      'setCheckedNotificationReadStatus',
    ]),
    ...mapActions('profile', [
      'sendNotificationReward',
    ]),
    spin() {
      if (!this.clicked && !this.hasMadeASpin) {
        this.clicked = true;
        this.initSpinCounter();
        this.sendNotificationReward({ reward: this.notificationRewardId, notif: this.checkedNotificationId }).then((response) => {
          this.haveRewardResponse = true;
          if (this.normalDurationPassed) {
            this.showResult = true;
            // stopSpinningTheWheel();
          }
          this.result = JSON.parse(response.data.data).result;
          if (this.result) {
            this.prizeName = JSON.parse(response.data.data).prize || this.notificationRewardName;
            this.hasMadeASpin = true;
          }
          this.clearData();
        }).catch((error) => {
          // eslint-disable-next-line
          console.log('error while redeem reward: ' + error);
          this.setDisableDuration();
          spinTheWheel(this.numOfClicks, this.degree, 2); // spin the wheel to "try again" state
        });
        spinTheWheel(this.numOfClicks, this.degree, this.calculateResult());
      }
    },
    styleClick() {
      return this.clicked ? { 'pointer-events': 'none' } : {};
    },
    setDisableDuration() {
      this.disableDuration = true;
    },
    determineResult() {
      switch (this.result) {
      case 'WIN': return true;
      case 'LOSE':
      default: return false;
      }
    },
    calculateResult() {
      return this.notificationPrizeWon ? this.getRewardId() : 5; // 5: try again state
    },
    getRewardId() {
      return parseInt(this.notificationRewardName.substr(this.notificationRewardName.indexOf('.') + 1), 10) + 1;
    },
    setDuration() {
      this.normalDurationPassed = true;
      if (this.haveRewardResponse) {
        this.showResult = true;
        // stopSpinningTheWheel();
      }
    },
    initSpinCounter() {
      setTimeout(this.setDuration, 4000); // do action after 4 seconds passed (minimum spin wheel duration)
    },
    clearData() {
      this.setNotificationRewardId({ value: '' });
      this.setCheckedNotificationId({ value: '' });
      this.setNotificationRewardName({ value: '' });
      this.setNotificationPrizeWon({ value: false });
      this.setCheckedNotificationReadStatus({ value: false });
    },
    showModal() {
      /* eslint-disable */
      const vm = this;
      this.$nextTick(() => {
        // open modal
        $('.modal,.modal-overlay').fadeIn(200);
        // show/hide modal
        $('.modal-close, .modal-overlay').click(function () {
          vm.$emit('close');
          $('#spinning').fadeOut();
        });
      });
      /* eslint-enable */
    },
  },
  computed: {
    ...mapState('profile', [
      'checkedNotificationId',
      'checkedNotificationReadStatus',
      'notificationRewardId',
      'notificationRewardName',
      'notificationPrizeWon',
    ]),
    ...mapGetters('i18n', [
      'getTranslations',
    ]),
  },
};
</script>

<style scoped>
  .noSpin{
    width:100%;
    height:100%;
    -webkit-transition: all 0s cubic-bezier(0,.99,.44,.99) !important;
    -moz-transition:    all 0 cubic-bezier(0,.99,.44,.99) !important;
    -o-transition:      all 0s cubic-bezier(0,.99,.44,.99) !important;
    -ms-transition:     all 0s cubic-bezier(0,.99,.44,.99) !important;
    transition:         all 0s cubic-bezier(0,.99,.44,.99) !important;
  }
  .spinNormal{
    width:100%;
    height:100%;
    -webkit-transition: all 4s cubic-bezier(0,.99,.44,.99) !important;
    -moz-transition:    all 4 cubic-bezier(0,.99,.44,.99) !important;
    -o-transition:      all 4s cubic-bezier(0,.99,.44,.99) !important;
    -ms-transition:     all 4s cubic-bezier(0,.99,.44,.99) !important;
    transition:         all 4s cubic-bezier(0,.99,.44,.99) !important;
  }
</style>




// WEBPACK FOOTER //
// src/components/home/modals/SpinWheel.vue